import { Add } from "@mui/icons-material";
import {
	Button,
	Menu,
	MenuItem,
	Tooltip,
	useMediaQuery,
	useTheme,
} from "@mui/material";
import { useState } from "react";
import ModalsWrapper from "src/components/Modals/ModalsWrapper";
import { useApiMutation } from "src/hooks/useApiMutation";
import CreateFairStall from "./CreateFairStall";
import ImportFromXcel from "./ImportFromXcel";

const StallCreateOptions = () => {
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

	const [openDialogue, setOpenDialogue] = useState(false);
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

	const isMenuOpen = Boolean(anchorEl);

	const { mutate: createFromPrev, isPending } = useApiMutation<void, void>({
		method: "POST",
		endPoint: "/api/fair/stall/previous-stall",
		invalidateQueries: ["FairStalls"],
	});

	const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleMenuClose = () => {
		setAnchorEl(null);
	};

	const handleActionSelect = (action: string) => {
		handleMenuClose();
		if (action === "create") {
			setOpenDialogue(true);
		} else if (action === "file") {
			createFromPrev();
		} else if (action === "import") {
			createFromPrev();
		}
	};

	return (
		<div>
			<Tooltip title='Create New Stall'>
				<Button
					style={{
						padding: "9px 0",
					}}
					onClick={handleMenuOpen}
					variant='contained'
				>
					<Add />
				</Button>
			</Tooltip>
			{/* New Stall Creation Options */}
			<Menu
				anchorEl={anchorEl}
				open={isMenuOpen}
				onClose={handleMenuClose}
				MenuListProps={{
					"aria-labelledby": "create-stall-button",
				}}
			>
				<MenuItem onClick={() => handleActionSelect("create")}>
					Create New
				</MenuItem>
				<ImportFromXcel />
				<MenuItem onClick={() => handleActionSelect("import")}>
					{isPending ? "Importing..." : "Import Previous"}
				</MenuItem>
			</Menu>
			{/* Modal */}

			<ModalsWrapper
				setShowModal={setOpenDialogue}
				modalData={{ title: "Create Fair Stall" }}
				showModal={openDialogue}
			>
				<CreateFairStall handleClose={() => setOpenDialogue(false)} />
			</ModalsWrapper>
		</div>
	);
};

export default StallCreateOptions;
